<div class="sidebar_menu" [@onSideNavChange]="sidebarState" (click)="$event.stopPropagation()">
  <mat-nav-list class="menu-list">
    <div>
      <a mat-list-item id="menubar" title="meni" (click)="toggleSideNav()">
        <!-- <mat-icon class="icon" style="cursor: pointer;" [@iconAnimation]="sidebarState">menu</mat-icon> -->
        <span class="icon fa fa-bars" [@iconAnimation]="sidebarState"></span>
        <span class="ebox-logo" [@labelAnimation]="sidebarState">
          <img class="ebox-logo-img" src="/assets/img/e-box-logo-horizontal.png" alt="logo">
        </span>
      </a>
      <br [@labelAnimation]="sidebarState">
    </div>

    <div *ngFor="let nav of navigations">
      <div class="menu-category" [@labelAnimation]="sidebarState">{{ nav.title }}</div>
      <a *ngFor="let route of nav.routes" mat-list-item routerLinkActive="active-list-item" [routerLink]="route.path" [title]="route.title">
        <!-- <mat-icon class="icon" [@iconAnimation]="sidebarState">{{ route.icon }}</mat-icon> -->
        <span class="icon {{ route.icon }}" [@iconAnimation]="sidebarState" aria-hidden="true"></span>
        <span class="label" [@labelAnimation]="sidebarState">{{ route.title }}</span>
      </a>
      <br [@labelAnimation]="sidebarState">
    </div>
  </mat-nav-list>
</div>

<!-- a -->
